<ng-container *transloco="let t">
  <div class="row justify-content-between mt-3 gy-3">
    <div class="col-12 col-lg-auto">
      <h3 class="text-secondary">
        <lucide-icon [img]="icons.coins"></lucide-icon>
        Prix
      </h3>
    </div>
    @if (canEdit()) {
      <div class="col-12 col-lg-auto">
        <div class="d-grid gap-2 d-md-block">
          <button type="button" class="btn btn-sm btn-outline-primary"
                  (click)="editClick()">
            <lucide-icon [img]="icons.edit" [size]="16"></lucide-icon>
            Indiquer la tarification
          </button>
        </div>
      </div>
    }
  </div>

  <div class="row">
    @if (!hasPrice()) {
      <div class="col-12">Tarifs sur demande</div>
    } @else {
      <div class="col-12 my-1">
        @if (activity()?.isFree) {
          <lucide-icon [img]="icons.free"></lucide-icon> L'accès à cette activité est gratuit
        } @else if (activity()?.isFree === false) {
          {{ activity() | activityPrice: isRecurrent() }}
        }
      </div>
    }

    @if (activity()?.hasTrialOffers) {
      <div class="col-12">
        <lucide-icon [img]="icons.check"></lucide-icon>
        Essai gratuit
      </div>
    }
    @if (activity()?.hasDiscountOffers) {
      <div class="col-12">
        <lucide-icon [img]="icons.check"></lucide-icon>
        Réductions pour certaines audiences
      </div>
    }
    @if (activity()?.priceDescription) {
      <div class="col-12 my-2 ml-description">
        {{ activity()?.priceDescription }}
      </div>
    }
  </div>
</ng-container>
